import { isInViewport } from "../../src/utils/globalFunctions";

export const typeWriter = (textElem, text) => {
	return new Promise((resolve) => {
		let typeCount = 0; // Counter specific to this text element
		const typeSpeed = 100;

		const typeCharacter = () => {
			if (typeCount < text?.length) {
				textElem.innerHTML += text.charAt(typeCount);
				typeCount++;
				setTimeout(typeCharacter, typeSpeed);
			} else {
				textElem.classList.add("finished");
				textElem.classList.remove("started");
				setTimeout(() => resolve(true), 100);
			}
		};

		typeCharacter();
	});
};

export const initTypedText = () => {
	const allTypedTexts = document.querySelectorAll(
		".typed-text:not(.typed-not-auto)",
	);
	for (const textItem of allTypedTexts) {
		if (!isInViewport(textItem)) continue;
		if (
			!textItem.classList.contains("started") &&
			!textItem.classList.contains("finished") &&
			textItem.hasAttribute("data-text")
		) {
			textItem.classList.add("started");
			const text = textItem.getAttribute("data-text");
			textItem.removeAttribute("data-text");
			typeWriter(textItem, text).then();
		}
	}
};
